'use client';

import { Typography } from '@curology/ui-components-web';

const PageHeader = () => {
  return <Typography size="h1">Your recommended routine</Typography>;
};

export { PageHeader };
